<template>
    <div class="carousel-content">

        <div class="upload">
            <el-upload :action="uploadApi" :show-file-list="false" :on-success="handleCarouselSuccess"
                :before-upload="beforeCarouselUpload" :on-error="Loading.instance.close" with-credentials>
                <el-button type="primary">上传轮播图</el-button>
                <template #tip>
                    <div class="el-upload__tip">
                        请上传图片类型文件
                    </div>
                </template>
            </el-upload>
        </div>

        <div class="table">

            <div class="title">
                轮播图管理
            </div>

            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="order" label="序号" />
                <el-table-column prop="path" label="图片">
                    <template #default="{ row }">
                        <el-image style="width: 100px; height: 100px" preview-teleported :src="row.path"
                            :min-scale="0.2" fit="cover" :preview-src-list="[row.path]" />
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column label="操作">
                    <template #default="{ row }">
                        <el-button size="small" type="danger" @click="onDelete(row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <div class="page">
            <Pagination :page-size="pageSize" v-model:current-page="currentPage" :total-page="totalPage"
                @current-page-change="pageChange"></Pagination>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { Action } from '@/typeDefine/CommonTypes';
import { CarouselType } from '@/typeDefine/EntityType';
import { AdminGetCarouselByPageResponse, BaseResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { nextTick, onMounted, onUpdated, ref, Ref } from 'vue';
import Pagination from '../Pagination.vue';
import { ConstantField } from '@/constant/ConstantField';
import { ElLoading, ElMessage, ElMessageBox, LoadingOptions, UploadProps } from 'element-plus';
import { Loading } from '@/util/Loading';

//当前页
const currentPage: Ref<number> = ref(1)
//页大小
const pageSize: Ref<number> = ref(10)
//总页数
const totalPage: Ref<number> = ref(0)

//表格内容
const tableData: Ref<CarouselType[]> = ref([])

//上传轮播接口
const uploadApi: string = `${ConstantField.SERVER}/carousel/admin/add`

onMounted(() => nextTick(() => getCarousel(currentPage.value)))

//分页获取轮播图
const getCarousel: Action<[number, number?]> = async (currentPage: number, pageSize?: number) => {

    const response: AdminGetCarouselByPageResponse = await Api.instance.adminGetCarouselByPage({
        startPage: currentPage,
        pageSize,
    })

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        requestAnimationFrame(() => {
            tableData.value = response.data.carousel
            totalPage.value = response.data.totalPage

            let i: number = 0
            tableData.value = tableData.value.map(item => {
                const { path, ...rest } = item
                return {
                    ...rest,
                    order: ++i,
                    path: `${path}`,
                }
            })
        })
    }
}

//当前页改变
const pageChange: Action<[number]> = (value: number) => {
    getCarousel(value)
}

//删除轮播
const onDelete: Action<[CarouselType]> = async (row) => {
    ElMessageBox.confirm('将执行删除该轮播图操作,是否确定?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(() => onDeleteHandler(row.id)).catch(() => { })
}

const onDeleteHandler: Action<[number]> = async (id: number) => {

    const response: BaseResponse = await Api.instance.adminDeleteCarousel({
        id,
    })

    UtilMethods.showMessageToast(response)

    if (response.code === ResponseCode.OK) {
        refresh()
    }
}

//上传图片前校验
const beforeCarouselUpload: UploadProps['beforeUpload'] = (rawFile) => {
    if (!rawFile.type.startsWith('image')) {
        ElMessage.error('请上传图片类型文件')
        return false
    }

    Loading.instance.open('上传中...')
    return true
}

const handleCarouselSuccess: UploadProps['onSuccess'] = (response, uploadFile) => {

    Loading.instance.close()

    if (response === null) {
        return
    }

    UtilMethods.showMessageToast(response)

    if (response?.code === ResponseCode.OK) {
        refresh()
    }
}

//刷新表格
const refresh: Action = () => {
    currentPage.value = 1
    getCarousel(currentPage.value)
}

</script>

<style lang="css" scoped>
.carousel-content .upload {
    margin: 20px 0;
}

.carousel-content .page {
    display: flex;
    justify-content: right;
    margin: 0 20px;
}

.carousel-content .table .title {
    font-size: 20px;
    font-weight: bold;
}
</style>